import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { uploadAudioAnnouncementFiles } from '../../services/AudioAnnouncementService';
import type {
  AudioAnnouncementUploadRequest,
  AudioAnnouncementUploadResponse,
} from '../../types/AudioAnnouncement';

type Result = UseMutationResult<AudioAnnouncementUploadResponse, Error, AudioAnnouncementUploadRequest>;

function useUploadAudioAnnouncementFiles(
  successCb: (res: AudioAnnouncementUploadResponse) => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(uploadAudioAnnouncementFiles, {
    onSuccess: (data, variables) => {
      successCb(data);
      queryClient.invalidateQueries({
        queryKey: ['audio-announcement', variables.fleetId],
      });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useUploadAudioAnnouncementFiles;
